import { render } from "./BoardDataStatistic.vue?vue&type=template&id=64add90b&scoped=true"
import script from "./BoardDataStatistic.vue?vue&type=script&lang=js"
export * from "./BoardDataStatistic.vue?vue&type=script&lang=js"

import "./BoardDataStatistic.vue?vue&type=style&index=0&id=64add90b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64add90b"],['__file',"src/components/h5/board/BoardDataStatistic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64add90b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64add90b', __exports__)) {
    api.reload('64add90b', __exports__)
  }
  
  module.hot.accept("./BoardDataStatistic.vue?vue&type=template&id=64add90b&scoped=true", () => {
    api.rerender('64add90b', render)
  })

}


export default __exports__